import React from "react";
import classes from "./CampaignImage.module.scss";

/**
 * キャンペーン画像プロパティ
 */
type CampaignImageProps = {
  /** 画像URL */
  image: string;
  /** クラス指定 */
  className?: string;
};

/**
 * キャンペーン画像コンポーネント
 * @param props キャンペーン画像プロパティ
 */
const CampaignImage: React.FC<CampaignImageProps> = (props) => {
  return (
    <div
      className={`${props.className} d-flex align-items-center justify-content-center`}
    >
      <div className={classes.campaignImageContainer}>
        <img className="img-fluid d-inline" src={props.image} alt="" />
      </div>
    </div>
  );
};

export default CampaignImage;
